import React, { useRef } from "react";
import {Button} from '../../components/ui'
const TradeFileUploader = ({ onChange, id }) => {
  const openFileDialog = () => {
    document.getElementById(id).click();
  };

  return (
    <div className="text-center">
      <input
        type="file"
        id={id}
        multiple
        // onChange={(e) => onChange([...e.target.files])}
        onChange={(event) => {
          onChange(event);
          event.target.value = "";
        }}
        className="hidden"
      />
      <Button onClick={openFileDialog} variant="outlined-primary" className="rounded-2xl">
        + Upload
      </Button>
    </div>
  );
};
export default TradeFileUploader;